import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar";

function About() {
  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">About Us</h2>
          <article className="article">
            <div className="article-inner">
              <p>
                Welcome to <strong>APK Downloads</strong> a premium APK free
                download platform offering Android applications and games. We
                created this platform because people are finding lots of apps on
                the internet but they are not finding them properly.
              </p>
              <h2>What we offer</h2>
              <ul>
                <li>Free Android apps and games</li>
                <li>Latest launchers and wallpapers</li>
                <li>Updated applications with full details</li>
                <li>No cost for downloads or for publishing your app</li>
              </ul>
              <h2>What you can do</h2>
              <p>
                Visitors can download apps without restrictions and request
                information about specific applications. Developers can also
                submit their own apps for publication on our platform at no charge.
              </p>
              <h2>Publishing requirements</h2>
              <p>
                Developers must be at least 18 years old to publish. We request
                your contact details and reserve the right to verify submitted
                applications. We explicitly reject adult, gambling, sexual or any
                type of violence apps as a policy violation.
              </p>
              <div className="info-box">
                <strong>Note:</strong> We are not a partner of Google apps, but we
                will allow Google Play Store publishers to distribute on our
                platform as well. If you have any questions, reach out through our
                contact page.
              </div>
            </div>
          </article>
        </Col>
        <Col lg={4}><Sidebar /></Col>
      </Row>
    </Container>
  );
}

export default About;
